import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { FootingAnalyzeRequest, FootingAnalyzeResponse } from './types';

function useDebounced<T>(value: T, ms = 200): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(id);
  }, [value, ms]);
  return debounced;
}

export function useFootingAnalysis(request: FootingAnalyzeRequest) {
  const debounced = useDebounced(request, 200);
  return useQuery<FootingAnalyzeResponse>({
    queryKey: ['zapatas', 'analyze', debounced],
    queryFn: async () => {
      const { data } = await api.post<FootingAnalyzeResponse>('/api/zapatas/isolated/analyze', debounced);
      return data;
    },
    placeholderData: (prev) => prev,
    retry: 0,
  });
}
